import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6ee0bbcb"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "layout-footer"
};
const _hoisted_2 = {
  class: "footer-content"
};
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"left\" data-v-6ee0bbcb><div class=\"f_title\" data-v-6ee0bbcb>关注或联系我们</div><div class=\"small_text\" data-v-6ee0bbcb> 添加咨询二维码，或关注公众号、视频号，快速了解实时资讯 </div><div class=\"qrcode-box\" data-v-6ee0bbcb><img class=\"qrcode-img\" src=\"https://miaosu-1313118321.cos.ap-guangzhou.myqcloud.com/20240108153400_code-zixun.png\" alt=\"\" data-v-6ee0bbcb><img class=\"qrcode-img\" src=\"https://miaosu-1313118321.cos.ap-guangzhou.myqcloud.com/20240108153400_code-gongzhonghao.png\" alt=\"\" data-v-6ee0bbcb><img class=\"qrcode-img\" src=\"https://miaosu-1313118321.cos.ap-guangzhou.myqcloud.com/20240108153400_code-shipinhao.png\" alt=\"\" data-v-6ee0bbcb></div><div class=\"tel\" data-v-6ee0bbcb>服务热线：13580527446</div></div>", 1);
const _hoisted_4 = {
  class: "right"
};
const _hoisted_5 = {
  class: "col"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "c_title"
}, "产品服务", -1));
const _hoisted_7 = {
  class: "col"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "c_title"
}, "解决方案", -1));
const _hoisted_9 = {
  class: "col"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "c_title"
}, "了解蒜小账", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icp"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "icp_lead"
}, "备案号："), /*#__PURE__*/_createElementVNode("a", {
  class: "icp_link",
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
}, "粤ICP备2023083440号")], -1));
import { useRouter } from "vue-router";
export default {
  __name: 'footer',
  setup(__props) {
    const router = useRouter();
    function jumpPage(url) {
      router.push(url);
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", {
        class: "i_text",
        onClick: _cache[0] || (_cache[0] = $event => jumpPage('/product/erp'))
      }, " 蒜小账（ERP） "), _createElementVNode("div", {
        class: "i_text",
        onClick: _cache[1] || (_cache[1] = $event => jumpPage('/product/ai'))
      }, " 蒜小智（AI系统） "), _createElementVNode("div", {
        class: "i_text",
        onClick: _cache[2] || (_cache[2] = $event => jumpPage('/product/wms'))
      }, " 蒜小仓（WMS） "), _createElementVNode("div", {
        class: "i_text",
        onClick: _cache[3] || (_cache[3] = $event => jumpPage('/product/robot'))
      }, " 小蒜机器人 ")]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", {
        class: "i_text",
        onClick: _cache[4] || (_cache[4] = $event => jumpPage('/home?tab=订单'))
      }, "智慧订单"), _createElementVNode("div", {
        class: "i_text",
        onClick: _cache[5] || (_cache[5] = $event => jumpPage('/home?tab=财务'))
      }, "智慧财务"), _createElementVNode("div", {
        class: "i_text",
        onClick: _cache[6] || (_cache[6] = $event => jumpPage('/home?tab=货物'))
      }, "智慧货物")]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", {
        class: "i_text",
        onClick: _cache[7] || (_cache[7] = $event => jumpPage('/about'))
      }, "关于我们"), _createElementVNode("div", {
        class: "i_text",
        onClick: _cache[8] || (_cache[8] = $event => jumpPage('/case'))
      }, "客户案例"), _createElementVNode("div", {
        class: "i_text",
        onClick: _cache[9] || (_cache[9] = $event => jumpPage('/service'))
      }, "服务保障")])])]), _hoisted_11]);
    };
  }
};